import { DISPATCH_REDEEM_PLASTIC_MODAL } from '@/src/common/reducers/constants'
import { FullWidthWhiteBox } from '@/src/modules/account/AccountStyledComponents'
import HeadlineEyebrow from '@/src/common/components/marketing/headlines/HeadlineEyebrow'
import Button from '@/src/common/components/marketing/buttons/Button'
import { usePGPlusStepAndModalContext } from '@/src/common/contexts/PGPlusModalAndStepContext'

const VirtualVisaRedemptionOptions = () => {
    const { dispatch } = usePGPlusStepAndModalContext()
    return (
        <FullWidthWhiteBox className={'white-box'}>
            <HeadlineEyebrow
                className={'headline-eyebrow'}
                label={'Ready for something new?'}
            />
            <p>
                BuyGiftCards.com offers the most flexible gifts in the nation.
            </p>
            <Button
                variant={'primaryOutline'}
                label={'get a plastic card'}
                textTransform={'uppercase'}
                showArrow={true}
                onClick={() =>
                    dispatch({
                        type: DISPATCH_REDEEM_PLASTIC_MODAL,
                    })
                }
            />
        </FullWidthWhiteBox>
    )
}

export default VirtualVisaRedemptionOptions
